import moment from 'moment';
import React from 'react';
import { render } from 'react-dom';
import jsonGet from '../../util/jsonGet';

import { BACKEND_DATE_FORMAT } from '../../config/helpers';

import ErrorMessage from '../react/Core/ErrorMessage';
import Loading from '../react/Core/Loading';
import PackageCarousel from '../react/PackageCarousel';
import { addCultureAndFallbackToParamsFromLocalStorage } from '../../util/culture';

export default class SimilarPackageCarouselRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { model, searchApi, siteId } = this.context.dataset;
    if (!model || !searchApi || !siteId) throw Error('Missing a required dataset');

    let jsonModel;
    try {
      jsonModel = JSON.parse(model);
    } catch (e) {
      jsonModel = undefined;
      console.error('Error parsing json: ', model);
    }

    const urlSearchParams = new URLSearchParams(window.location.search);
    const tourKey = urlSearchParams.get('TourId') || urlSearchParams.get('tourId');

    const searchRequest = {
      ...(jsonModel.durationFilterKey && {
        durations: jsonModel.durationFilterKey.replace(/-/g, ''),
      }),
      ...(jsonModel.minimumPrice && { priceFrom: jsonModel.minimumPrice }),
      ...(jsonModel.maximumPrice && { priceTo: jsonModel.maximumPrice }),
      ...(jsonModel.tourTypeFilterKey && {
        packageTypes: jsonModel.tourTypeFilterKey.replace(/-/g, ''),
      }),
      ...(jsonModel.tournamentFilterKey && {
        tournaments: jsonModel.tournamentFilterKey.replace(/-/g, ''),
      }),
      fromDate: moment().format(BACKEND_DATE_FORMAT),
      siteId,
      includeSoldOutPackages: false,
      tourKey,
      page: 1, // required
    };
    const tourSearchApiRequestOptions =
      addCultureAndFallbackToParamsFromLocalStorage(searchRequest);

    const { soldOutText, perPersonText } = jsonModel;

    jsonGet(searchApi, tourSearchApiRequestOptions, (response) => {
      if (response.errorCode) {
        return render(<ErrorMessage text={response.message} />, this.context);
      }

      return render(
        SimilarPackageCarouselRender.renderMain(response, soldOutText, perPersonText),
        this.context
      );
    });

    return render(
      SimilarPackageCarouselRender.renderMain(undefined, soldOutText, perPersonText),
      this.context
    );
  }

  static renderMain(data, soldOutText, perPersonText) {
    return data ? (
      <PackageCarousel {...data} soldOutText={soldOutText} perPersonText={perPersonText} />
    ) : (
      <Loading />
    );
  }
}
